export const extendedReportCardsInfo = [
    {
        id: 'general-info',
        title: 'extended_report.general_info',
        content: 'extended_report.general_info_description'
    },
    {
        id: 'financial-info',
        title: 'extended_report.financial_info_title',
        content: 'extended_report.financial_info_description'
    },
    {
        id: 'performance-monitoring',
        title: 'extended_report.performance_monitoring_title',
        content: 'extended_report.performace_monitoring_description'
    },
    {
        id: 'project-milestones',
        title: 'extended_report.project_milestones_title',
        content: 'extended_report.project_milestones_description'
    },
    {
        id: 'early-warnings',
        title: 'extended_report.early_warnings_title',
        content: 'extended_report.early_warnings_description'
    },
    {
        id: 'agreements',
        title: 'extended_report.agreements_title',
        content: 'extended_report.agreements_description'
    },
    {
        id: 'enviromental-safeguards',
        title: 'extended_report.enviromental_safeguards_title',
        content: 'extended_report.enviromental_safeguards_description'
    },
]

export const extendedProjectPMRReportCardsInfo = [
    {
        id: 'general-info',
        title: 'extended_report.general_info',
        content: 'extended_report.general_info_content'
    },
    {
        id: 'financial-info',
        title: 'one_pager_report.financial_information',
        content: 'extended_report.financial_information_content'
    },
    {
        id: 'current_accordances',
        title: 'extended_report.current_accordances',
        content: 'extended_report.current_accordances_content'
    },
    {
        id: 'risks',
        title: 'extended_report.risks',
        content: 'extended_report.risks_content'
    },
    {
        id: 'acquisitions',
        title: 'last_adquisitions',
        content: 'extended_report.acquisitions_content'
    },
    {
        id: 'supervition',
        title: 'extended_report.supervition',
        content: 'extended_report.supervition_content'
    },
]

export const extendedProjectTCDIReportCardsInfo = [
    {
        id: 'general-info',
        title: 'extended_report.general_info',
        content: 'extended_report.general_info_tcdi_content'
    },
    {
        id: 'financial-info',
        title: 'one_pager_report.financial_information',
        content: 'extended_report.financial_information_tcdi_content'
    },
    {
        id: 'current_accordances',
        title: 'extended_report.current_accordances',
        content: 'extended_report.current_accordances_content'
    },
    {
        id: 'products',
        title: 'extended_report.products',
        content: 'extended_report.products_content'
    },
]

export const financialLayout = {
    lg: [
        { i: 'div1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'div2', x: 0, y: 2, w: 6, h: 1 },
        { i: 'div3', x: 6, y: 2, w: 6, h: 1 },
    ],
    md: [
        { i: 'div1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'div2', x: 0, y: 2, w: 6, h: 1 },
        { i: 'div3', x: 6, y: 2, w: 6, h: 1 },
    ],
    sm: [
        { i: 'div1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'div2', x: 0, y: 2, w: 6, h: 1 },
        { i: 'div3', x: 6, y: 2, w: 6, h: 1 },
    ],
    xs: [
        { i: 'div1', x: 0, y: 0, w: 6, h: 1 },
        { i: 'div2', x: 0, y: 2, w: 6, h: 1 },
        { i: 'div3', x: 0, y: 3, w: 6, h: 1 },
    ],
    xxs: [
        { i: 'div1', x: 0, y: 0, w: 6, h: 1 },
        { i: 'div2', x: 0, y: 2, w: 6, h: 1 },
        { i: 'div3', x: 0, y: 3, w: 6, h: 1 },
    ],
}

export const performanceMonitoring = {
    lg: [
        { i: 'div1', x: 0, y: 0, w: 6, h: 2 },
        { i: 'div2', x: 6, y: 0, w: 6, h: 1 },
        { i: 'div3a', x: 6, y: 1, w: 3, h: 1 },
        { i: 'div3b', x: 9, y: 1, w: 3, h: 1 },
    ],
    md: [
        { i: 'div1', x: 0, y: 0, w: 6, h: 2 },
        { i: 'div2', x: 6, y: 0, w: 6, h: 1 },
        { i: 'div3a', x: 6, y: 1, w: 3, h: 1 },
        { i: 'div3b', x: 9, y: 1, w: 3, h: 1 },
    ],
    sm: [
        { i: 'div1', x: 0, y: 0, w: 6, h: 2 },
        { i: 'div2', x: 6, y: 0, w: 6, h: 1 },
        { i: 'div3a', x: 6, y: 1, w: 3, h: 1 },
        { i: 'div3b', x: 9, y: 1, w: 3, h: 1 },
    ],
    xs: [
        { i: 'div1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'div2', x: 0, y: 1, w: 12, h: 1 },
        { i: 'div3a', x: 0, y: 2, w: 12, h: 1 },
        { i: 'div3b', x: 0, y: 3, w: 12, h: 1 },
    ],
    xxs: [
        { i: 'div1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'div2', x: 0, y: 1, w: 12, h: 1 },
        { i: 'div3a', x: 0, y: 2, w: 12, h: 1 },
        { i: 'div3b', x: 0, y: 3, w: 12, h: 1 },
    ],
}